import { DeliveryAddressService } from "Logic/DeliveryAddressService";
import { setDeliveryAddressesLoadingAction } from "./SetDeliveryAddressesLoadingAction";
import { setDeliveryAddressesErrorAction } from "./SetDeliveryAddressesErrorAction";
import { setDeliveryAddressesItemsAction } from "./SetDeliveryAddressesItemsAction";
import { clearDeliveryAddressesAction } from "./ClearDeliveryAddressesAction";

export const loadUserDeliveryAddressesAction =
  (args: {
    token: string;
    onAuthError: (msg: string) => void;
    onForbidden: (msg: string) => void;
  }) =>
  async (dispatch: any) => {
    const { token, onAuthError, onForbidden } = args;

    if (!token) {
      clearDeliveryAddressesAction()(dispatch);
      return;
    }

    const service = new DeliveryAddressService();

    // reset before fetch
    setDeliveryAddressesErrorAction(null)(dispatch);
    setDeliveryAddressesLoadingAction(true)(dispatch);

    try {
      await service.handleGetUserDeliveryAddresses({
        token,
        setLoading: (v) => setDeliveryAddressesLoadingAction(Boolean(v))(dispatch),
        setApiError: (msg) => setDeliveryAddressesErrorAction(msg ?? null)(dispatch),
        setItems: (items) => setDeliveryAddressesItemsAction(items)(dispatch),
        onAuthError,
        onForbidden,
      });
    } catch (e) {
      const msg = (e as Error)?.message || "Couldn’t fetch delivery addresses.";
      setDeliveryAddressesItemsAction([])(dispatch);
      setDeliveryAddressesErrorAction(msg)(dispatch);
    } finally {
      setDeliveryAddressesLoadingAction(false)(dispatch);
    }
  };
